import axios from "axios"
import {getToken, removeToken} from '@/utils/auth'
const service = axios.create({
    // baseURL: process.env.API_HOST, // url = base api url + request url process.env.API_HOST, //
    withCredentials: true, // send cookies when cross-domain requests
    timeout: 7000000 // request timeout
})
import { message } from '../utils/message'
//请求过滤器
service.interceptors.request.use((config) => {
  if(localStorage.getItem('UserAdmin')){
    config.headers.Authorization ='bearer ' + localStorage.getItem('UserAdmin')
  }
  return config;
  });

  service.interceptors.response.use(
    response => {
      // console.log(response)
      if (response.status === 200) {
        let res = response.data;
          if (response.config.responseType === 'blob') {
              return response
          }
          if(res.code && res.code !== 200) {
            if (res.code === 401) {
              localStorage.removeItem('UserAdmin')
              window.location.reload();
            }
            message.error(res.message || res.msg)
            return Promise.reject(res.message || res.msg)
          }
          return response.data;
        } else {
          return Promise.reject(new Error('请求异常'))
        }
      }
,
      error => {
        if (error.response.data.code === 401) {
          message.error(error.response.data.msg)
          localStorage.removeItem('UserAdmin')
          window.location.reload();
        }
        return Promise.reject(error)
      }
  )

export default service
